import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ExcelService } from '../excel.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { VillageStaffService } from '../village-staff.service';
import { AdminService } from 'src/app/admin/admin.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-permit',
  templateUrl: './permit.component.html',
  styleUrls: ['./permit.component.scss']
})
export class PermitComponent implements OnInit {
  public columnNames = {
    'Plate No': 'Plate No',
    'Month(MM/YY)': 'Month(MM/YY)',
    'User': 'User'
  };
  public maxDate;
  public permits = [];
  dateForm: FormGroup;
  public selectMonthError: boolean = false;
  public selectYearError: boolean = false;
  public disableBtn: boolean = false;
  public showSpinner: boolean = false;
  public confirm1: MatDialogRef<any> = null;
  public confirm2: MatDialogRef<any> = null;
  public firstYearDate = moment().startOf('year').format('YYYY-MM-DD');
  @ViewChild('confirmRef1') confirmRef1: TemplateRef<any>;
  @ViewChild('confirmRef2') confirmRef2: TemplateRef<any>;
  public years: any;
  public months = [
    { val: '0', name: 'Jan' },
    { val: '1', name: 'Feb' },
    { val: '2', name: 'Mar' },
    { val: '3', name: 'Apr' },
    { val: '4', name: 'May' },
    { val: '5', name: 'Jun' },
    { val: '6', name: 'Jul' },
    { val: '7', name: 'Aug' },
    { val: '8', name: 'Sep' },
    { val: '9', name: 'Oct' },
    { val: '10', name: 'Nov' },
    { val: '11', name: 'Dec' }
  ];
  constructor(private excelService: ExcelService,
    private villageStaffService: VillageStaffService,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.dateForm = this.formBuilder.group({
      month: [''],
      year: [''],
      plateNo: ['']
    });
    //this.getParkingReasons();

    this.onSubmitDates();

    this.adminService.getYearCycle().subscribe(res => {
      if (res && res.yearsList && res.yearsList.length) {
        this.years = res.yearsList.sort((a, b) => a.year - b.year);
      }
    });

    this.dateForm.get('year').valueChanges.subscribe((year) => {
      if (year) {
        this.selectYearError = false;
        if (this.dateForm.value.month == "" || this.dateForm.value.month == null) {
          this.selectMonthError = true;
          this.disableBtn = true;
        } else {
          this.disableBtn = false;
        }
      }
    })
    this.dateForm.get('month').valueChanges.subscribe((month) => {
      if (month) {
        this.selectMonthError = false;
        if (this.dateForm.value.year == "" || this.dateForm.value.year == null) {
          this.selectYearError = true;
          this.disableBtn = true;
        } else {
          this.disableBtn = false;
        }
      }
    })

  }

  onSubmitDates() {
    this.showSpinner = true;
    let params = this.dateForm.value
    this.villageStaffService.getPartkingPermits(params).subscribe((res: any) => {
      let UpdatedArr = [];
      if (res && res.validPermit) {
        let monthYear;
        res.validPermit.sort((a, b) => {
          let bdate = a.month;
          let adate = b.month;
          let compared = bdate - adate;
          if (compared == 0) {
            if (a.vehicle && b.vehicle) {
              compared = a.vehicle ? a.vehicle.plateNo.localeCompare(b.vehicle.plateNo) : null;
            }
          }
          return compared;
        });
        res.validPermit.sort();
        res.validPermit.map((data: any) => {
          if (data.month && data.year && data.vehicle && data.vehicle.states && data.user) {
            monthYear = ((data.month + 1) + "/" + data.year)
            UpdatedArr.push({ 'Plate No': data.vehicle.states.state + '-' + data.vehicle.plateNo, 'Month(MM/YY)': monthYear ? monthYear : null, 'User': data.user ? data.user.userName : null });
          }
        });
      }
      // res.validPermit.map((data: any) => UpdatedArr.push({ 'Plate No': data.vehicle.states.state + '-' + data.vehicle.plateNo, 'Month(MM/YY)': moment(data.date_col_formed).format("MM/YY") }));
      this.permits = UpdatedArr.sort();
      this.showSpinner = false;
    })
  }

  reset() {
    this.dateForm.reset();
    this.onSubmitDates();
    this.selectMonthError = false;
    this.selectYearError = false;
  }

  onClose1() {
    this.confirm1.close()
  }

  onClose2() {
    this.confirm2.close()
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.permits, 'sample');
  }

}
